import Modal from 'antd/lib/modal'
import 'antd/lib/modal/style'

const showModalWithDemoRestriction = () => {
    Modal.info({
        title: 'Демо режим',
        content:
            'Для продолжения оформления Вам необходимо заключить агентский договор в разделе: Агентский договор.',
    })
}

export default showModalWithDemoRestriction
